export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-random/src/defaultSource.js
// module id = ../../../../d3-random/src/defaultSource.js
// module chunks = 3